exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading__badge-app-loading___2k4vi {\n  max-width: 100%;\n  display: flex;\n  margin: auto;\n  justify-self: center;\n  align-self: center; }\n", "", {"version":3,"sources":["/app/client/src/components/loading.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB,EAAE","file":"loading.scss","sourcesContent":[".badge-app-loading {\n  max-width: 100%;\n  display: flex;\n  margin: auto;\n  justify-self: center;\n  align-self: center; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge-app-loading": "loading__badge-app-loading___2k4vi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/components/loading.scss
// module id = 240
// module chunks = 0